import { render } from "./MChatR.vue?vue&type=template&id=5b4017a4&scoped=true"
import script from "./MChatR.vue?vue&type=script&lang=js"
export * from "./MChatR.vue?vue&type=script&lang=js"

import "./MChatR.vue?vue&type=style&index=0&id=5b4017a4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5b4017a4"

export default script